import { render } from "./Shop.vue?vue&type=template&id=7e7d9718"
import script from "./Shop.vue?vue&type=script&lang=js"
export * from "./Shop.vue?vue&type=script&lang=js"
script.render = render

export default script